import React from "react";
import {
  Create,
  SimpleForm,
  DateInput,
  BooleanInput,
  Toolbar,
  required,
  SelectInput
} from "react-admin";
import TimeInput from "../../fields/TimeInput";
import LocationReferenceInput from "../LocationReferenceInput";
import SaveWithLocationButton from "../SaveWithLocationButton";
import { makeStyles } from "@material-ui/core/styles";
import SportCodeInput from "./SportCodeInput";
import SeasonCodeInput from "./SeasonCodeInput";
import GameSchoolReferenceInput from "./GameSchoolReferenceInput";

const useStyles = makeStyles({
  button: {
    marginRight: "10px"
  }
});

const GameCreateToolbar = (props) => {
  const styles = useStyles();
  return (
    <Toolbar {...props}>
      <SaveWithLocationButton
        label="Save"
        className={styles.button}
        redirect="edit"
      />
      <SaveWithLocationButton
        label="Save and add another"
        className={styles.button}
        redirect="create"
      />
    </Toolbar>
  );
};

const DefaultGameCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm toolbar={<GameCreateToolbar />}>
        <DateInput label="Date" source="date" validate={[required()]} />
        <TimeInput label="Time" source="time" />
        <LocationReferenceInput
          source="location"
          reference="locations"
          allowEmpty
        />
        <BooleanInput label="Is District Game" source="gameIsDistrict" />
        <BooleanInput label="Is Top Game" source="isTopGame" />
        <SelectInput
          source="playoffRound"
          allowEmpty={true}
          choices={[
            { id: "BI_DISTRICT", name: "Bi-District" },
            { id: "AREA", name: "Area" },
            { id: "REGIONAL_QUARTERFINAL", name: "Regional Quaterfinal" },
            { id: "REGIONAL_SEMIFINAL", name: "Regional Semifinal" },
            { id: "REGIONAL_FINAL", name: "Regional Final" },
            { id: "STATE_SEMIFINAL", name: "State Semifinal" },
            { id: "STATE_FINAL", name: "State Final" }
          ]}
        />
        <SportCodeInput />
        <SeasonCodeInput />
        <GameSchoolReferenceInput type="home" />
        <GameSchoolReferenceInput type="away" />
      </SimpleForm>
    </Create>
  );
};

export default DefaultGameCreate;
